import { linkRegExp } from './regExp';
import { FileType, TypeOfMessages, uploadFilesInfoType } from 'types';

export const createMessageReqBody = (fileInfo: uploadFilesInfoType) => {
  switch (fileInfo.fileExtension) {
    case FileType.BMP:
    case FileType.JPEG:
    case FileType.JPG:
    case FileType.PNG:
    case FileType.WEBP: {
      return {
        type: TypeOfMessages.PHOTO,
        attachmentFileId: fileInfo.id,
      };
    }
    default: {
      return {
        type: TypeOfMessages.FILE,
        attachmentFileId: fileInfo.id,
      };
    }
  }
};

export const getLinksFromMessage = (message: string) => {
  const matches = message.match(linkRegExp);
  return matches;
};
